export default __webpack_public_path__ + "static/form-multiple-action-buttons-do-285c0000ddbd44ef8d95623c37f932724eed499de13b34c8b8c6054bfd2cc0c8.png";